import { FormActions } from "../../components/common/FormActions";
import { BooleanTags } from "../../components/common/registerUtils";
import {
  createColumn,
  createViewAction,
  formatAmount,
  formatDateTime,
  numberFormat,
} from "../../utils/helpers";
import { URL_PENALTIES } from "../../utils/urls";

export const usePenalties = () => {
  const tableColumns = () => [
    createColumn("invoice_number", true, "Invoice Number"),
    createColumn("amount", false, "Amount"),
    createColumn("paid", true, "Paid"),
    createColumn("declaration", true, "Declaration"),
    createColumn("penalty_applied", true, "Penalty Applied"),
    createColumn("waived", true, "Waived"),
    createColumn("created_at", true, "Created At"),
    createColumn("actions", false, "Actions"),
  ];

  const tableData = (data: any) => {
    if (!data) return [];

    return data.map((item: any) => {
      return {
        ...item,
        amount: numberFormat(item?.amount),
        paid: <BooleanTags status={item?.paid} />,
        declaration: <BooleanTags status={item?.declaration} />,
        penalty_applied: <BooleanTags status={item?.penalty_applied} />,
        waived: <BooleanTags status={item?.waived} />,
        created_at: formatDateTime(item?.created_at),
        actions: (
          <FormActions actions={[createViewAction(URL_PENALTIES, item?.id)]} />
        ),
      };
    });
  };

  const viewData = (item: any) => {
    return {
      sections: [
        {
          title: "Penalties Details",
          fields: {
            ...item,
            amount: formatAmount(item?.amount),
            paid: <BooleanTags status={item?.paid} />,
            declaration: <BooleanTags status={item?.declaration} />,
            penalty_applied: <BooleanTags status={item?.penalty_applied} />,
            waived: <BooleanTags status={item?.waived} />,
            created_at: formatDateTime(item?.created_at),
          },
        },
      ],
    };
  };

  return {
    tableColumns,
    tableData,
    viewData,
  };
};
